import { createContext, type ReactNode, useContext, useState } from 'react';

interface TableControlsContextValue {
  searchTerm: string;
  setSearchTerm: (v: string) => void;
  availableColumns: string[];
  setAvailableColumns: (cols: string[]) => void;
  selectedColumns: string[];
  setSelectedColumns: (cols: string[]) => void;
  isModalOpen: boolean;
  setModalOpen: (v: boolean) => void;
  isEmpty: boolean;
  setIsEmpty: (v: boolean) => void;
}

const TableControlsContext = createContext<
  TableControlsContextValue | undefined
>(undefined);

export const TableControlsProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [availableColumns, setAvailableColumns] = useState<string[]>([]);
  const [selectedColumns, setSelectedColumns] = useState<string[]>([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isEmpty, setIsEmpty] = useState(false);

  return (
    <TableControlsContext.Provider
      value={{
        searchTerm,
        setSearchTerm,
        availableColumns,
        setAvailableColumns,
        selectedColumns,
        setSelectedColumns,
        isModalOpen,
        setModalOpen,
        isEmpty,
        setIsEmpty,
      }}
    >
      {children}
    </TableControlsContext.Provider>
  );
};

export const useTableControls = () => {
  const ctx = useContext(TableControlsContext);
  if (!ctx) throw new Error('useTableControls must be used within provider');
  return ctx;
};
